import request from '@/utils/request';

export function serviceAgreement(data) {
  return request({
    url: '/system/config/addOrUpdateServiceAgreement',
    method: 'POST',
    data
  });
}
export function serviceAgreementInfo(params) {
  return request({
    url: '/system/config/getServiceAgreement',
    method: 'POST',
    params
  });
}
export function privacyPolicy(data) {
  return request({
    url: '/system/config/addOrUpdatePrivacyPolicy',
    method: 'POST',
    data
  });
}
export function privacyPolicyInfo(params) {
  return request({
    url: '/system/config/getPrivacyPolicy',
    method: 'POST',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/base.js